export default __webpack_public_path__ + "7e3b69093fba57575cd510f2227f42be.png";